class SvgInfographic {
	constructor(domNode) {
		// Init
		this.init(domNode);
	}

	init(domNode) {
		this.container = domNode.parentElement;
		this.rootEl = domNode;
		this.svg = this.rootEl.querySelector("svg");
		this.mediaQuery = window.matchMedia("(min-width: 1024px)");

		this.options = {
			isReveal: this.getIsReveal(),
			isDirectionFixed: this.container.dataset.containerFixed,
			direction: this.rootEl.dataset.direction,
			containerDirection: this.getContainerDirection(),
			scrollPausedTime: 800,
			timer: null,
			runningTotalLength: 0,
		};

		this.observerOptions = {
			root: null,
			rootMargin: "0% 0% -5% 0%",
			threshold: 0.7,
		};

		// Add observer for scrolling animation
		this.observer = new IntersectionObserver(this.handleObserved, this.observerOptions);

		// Disable reveal for tablet and mobile
		if (!this.mediaQuery.matches) {
			this.options.isReveal = false;
		}

		// Debug
		console.log(this);

		this.destroyContentAnchors();

		// Load in correct SVG
		if (this.options.containerDirection === "horizontal") this.switchSvgDirection(this.mediaQuery);

		if (this.options.containerDirection === "vertical") this.initVertical();
		if (this.options.containerDirection === "horizontal") this.initHorizontal();

		this.setupOvalReveal();

		// Add event listeners
		this.addEventListeners();

		// Init placement on page load
		this.placeElementsInsideAnchors();
	}

	initVertical() {
		this.rootEl.querySelectorAll(".svg-draw-path").forEach((pathEl, index) => {
			const correctEl = this.getCorrectElement(pathEl);
			let totalLength = 0;
			let elId = correctEl.id;
			totalLength = correctEl.getTotalLength();

			this.options.runningTotalLength += totalLength;

			this.initPathDraw(pathEl, { index, totalLength });

			console.log("init vertical");
			this.createContentAnchors("vertical", { elId, pathEl });
		});
	}

	initHorizontal() {
		this.rootEl.querySelectorAll(".svg-draw-path").forEach((pathEl, index) => {
			const correctEl = this.getCorrectElement(pathEl);
			let totalLength = 0;
			let elId = correctEl.id;
			totalLength = correctEl.getTotalLength();

			this.options.runningTotalLength += totalLength;

			this.initPathDraw(pathEl, { index, totalLength });

			// Get the oval el
			let idNum = parseInt(elId.split("-")[2]) ? parseInt(elId.split("-")[2]) : 0;
			let ovalEl = this.rootEl.querySelector("#group-ovals").querySelector("#oval-" + idNum);
			if (ovalEl) {
				const svgWidth = this.svg.getBoundingClientRect().width;
				const ovalElX =
					ovalEl.getBoundingClientRect().left - this.svg.getBoundingClientRect().left + ovalEl.getBoundingClientRect().width / 2;
				let leftPercentage = (ovalElX / svgWidth) * 100;

				this.createAnchorEl({ elId: idNum, idNum, leftPercentage });
			}

			// this.createContentAnchors(this.options.containerDirection, { elId, pathEl });
		});
	}

	setupOvalReveal() {
		this.svg
			.querySelector("#group-ovals")
			.querySelectorAll('[id^="oval-"]')
			.forEach((oval) => {
				oval.classList.add("svg-oval");
				if (this.options.isReveal === false) {
					oval.classList.add("active");
				} else {
					oval.classList.remove("active");
				}
			});
	}

	createContentAnchors(direction, options = { elId: null, pathEl: null }) {
		if (direction === "horizontal") {
			this.rootEl
				.querySelector("#group-ovals")
				.querySelectorAll('[id^="oval-"]')
				.forEach((ovalEl, index) => {
					const svgWidth = this.svg.getBoundingClientRect().width;
					const ovalElX =
						ovalEl.getBoundingClientRect().left - this.svg.getBoundingClientRect().left + ovalEl.getBoundingClientRect().width / 2;
					const idNum = index + 1;
					let leftPercentage = (ovalElX / svgWidth) * 100;

					this.createAnchorEl({ elId: idNum, idNum, leftPercentage });
				});
		} else if (direction === "vertical") {
			let elId = options.elId;
			let elStartY = window.scrollY + this.rootEl.getBoundingClientRect().top;
			let pathElY = window.scrollY + options.pathEl.getBoundingClientRect().top - elStartY;
			let elEndY = window.scrollY + this.rootEl.getBoundingClientRect().top + this.rootEl.getBoundingClientRect().height - elStartY;
			const idNum = elId.split("-")[2] ? elId.split("-")[2] : 0;
			let topPercentage = (pathElY / elEndY) * 100;

			if (idNum > 0) {
				topPercentage += 2.4;
			}

			if (navigator.userAgent.toLowerCase().indexOf("firefox") > -1) {
				// Dirty bug fix for FireFox
				topPercentage += 4.9;
			}

			this.createAnchorEl({ elId, idNum, topPercentage });
		}
	}

	createAnchorEl(options = { elId: 0, idNum: 0, topPercentage: null, leftPercentage: null }) {
		let newDiv = document.createElement("div");
		newDiv.id = "anchor-" + options.elId;
		newDiv.classList.add("svg-anchor-point");
		newDiv.dataset.svg = options.elId;
		newDiv.dataset.anchorId = options.idNum;

		newDiv = this.positionAnchorEl(options, newDiv);

		if (!this.options.isReveal) {
			newDiv.classList.add("active");
		}

		this.rootEl.appendChild(newDiv);

		if (this.options.isReveal) {
			this.observer.observe(newDiv);
		} else {
			this.observer.unobserve(newDiv);
		}
	}

	positionAnchorEl(options = { elId: 0, idNum: 0, topPercentage: null, leftPercentage: null }, newDiv) {
		if (options.topPercentage !== null) {
			newDiv.style.top = options.topPercentage + "%";
		} else {
			newDiv.style.top = "initial";
		}

		if (options.leftPercentage !== null) {
			newDiv.style.left = options.leftPercentage + "%";
		} else {
			newDiv.style.left = "initial";
		}

		return newDiv;
	}

	destroyContentAnchors() {
		this.rootEl.querySelectorAll(".svg-anchor-point").forEach((anchor) => {
			anchor.remove();
		});
	}

	initPathDraw(pathEl, options = { index: 0, totalLength: 0 }) {
		if (this.options.isReveal) {
			pathEl.setAttribute("stroke-dasharray", options.totalLength);
			pathEl.setAttribute("stroke-dashoffset", options.totalLength);
			pathEl.style.setProperty("--animation-delay", options.index);
		}
	}

	getCorrectElement(pathEl) {
		if (pathEl.nodeName === "use") {
			const href = pathEl.getAttributeNS("http://www.w3.org/1999/xlink", "href");
			const realEl = document.querySelector(href);

			return realEl;
		} else {
			return pathEl;
		}
	}

	placeElementsInsideAnchors() {
		document.querySelectorAll(".capability__container").forEach((contentEl, index) => {
			// Get the target oval
			const targetOvalId = contentEl.dataset.oval;
			const targetOval = this.rootEl.querySelector("[data-anchor-id='" + targetOvalId + "']");

			if (contentEl.classList.contains("capability__container--cloned")) {
				// Skip this element as it is a cloned element
				return;
			} else {
				// Hide the real elements
				contentEl.classList.add("hidden");

				if (targetOval && targetOval.innerHTML.length > 0) {
					// Resize the image
					this.resizeElementInsideAnchor(targetOval.querySelector("img"), targetOval.offsetWidth);
					return;
				} else if (targetOval) {
					// Clone the real elements
					let clonedDiv = contentEl.cloneNode(true);
					clonedDiv.classList.add("capability__container--cloned");
					clonedDiv.classList.remove("hidden");

					// Size the image
					this.resizeElementInsideAnchor(clonedDiv.querySelector("img"), targetOval.offsetWidth);
					targetOval.appendChild(clonedDiv);
				}
			}
		});
	}

	addEventListeners() {
		this.mediaQuery.addEventListener("change", this.switchSvgDirection.bind(this));

		// Handle broken scrolling for a smoother animation of the line
		window.addEventListener("scroll", this.handleScroll.bind(this));

		// Handle starting load with active classes
		window.addEventListener("load", this.handleLoad.bind(this));

		window.addEventListener("resize", this.handleResize.bind(this));
	}

	getContainerDirection() {
		return this.container.dataset.containerDirection;
	}

	setContainerDirection(direction = "vertical") {
		this.container.dataset.containerDirection = direction;
		this.options.containerDirection = this.getContainerDirection();
	}

	getIsReveal() {
		return this.rootEl.dataset.reveal ? false : true;
	}

	setIsReveal(bool = false) {
		this.rootEl.dataset.reveal = bool;
		this.options.isReveal = bool;
	}

	switchSvgDirection(e) {
		if (e.matches) {
			// HORIZONTAL
			// console.log("desktop");
			if (this.options.isDirectionFixed === "false") {
				this.setIsReveal(this.options.isReveal);

				this.svg.setAttribute("viewBox", "0 0 1652 366");
				this.svg.getElementById("Homepage---desktop-full-view").setAttribute("transform", "");
				this.svg.getElementById("info-main-svg").setAttribute("transform", "");
				this.svg.getElementById("info-main-svg").style.transform = "translateY(100%) rotate(-90deg)";

				this.setContainerDirection("horizontal");
			}
		} else {
			// VERTICAL
			// console.log("mobile");
			if (this.options.isDirectionFixed === "false") {
				this.setIsReveal(true);

				this.svg.setAttribute("viewBox", "0 0 366 1652");
				this.svg.getElementById("Homepage---desktop-full-view").setAttribute("transform", "translate(-539 -1003)");
				this.svg.getElementById("info-main-svg").setAttribute("transform", "translate(549 1014)");
				this.svg.getElementById("info-main-svg").style.transform = "";

				this.setContainerDirection("vertical");
			}
		}

		this.resizeElements();
	}

	handleObserved(entries, observer) {
		console.log(observer);
		entries.forEach((entry, index) => {
			if (entry.isIntersecting) {
				console.log(entry.target.dataset);
				const realTarget = document.querySelector('#info-main-svg [*|href="#' + entry.target.dataset.svg + '"]');
				console.log({ realTarget });
				const maybeId = entry.target.dataset.svg.replace(/^\D+/g, "");
				const ovalTarget = document.querySelector("#group-ovals #oval-" + maybeId + "");
				if (ovalTarget) {
					ovalTarget.classList.add("active");
				}

				const ovalContentBoxes = document.querySelectorAll("[data-oval='" + maybeId + "']");
				ovalContentBoxes.forEach((ovalContent) => {
					if (ovalContent) {
						ovalContent.classList.add("active");
					}
				});

				realTarget.classList.add("active");
			}
		});
	}

	handleScroll() {
		if (this.options.timer !== null) {
			clearTimeout(this.options.timer);
		}

		this.options.timer = setTimeout(() => {
			// Get the svg-draw-path elements without active class
			this.rootEl.querySelectorAll(".svg-draw-path:not(.active)").forEach((pathEl, index) => {
				//   Now reset their delay
				pathEl.style.setProperty("--animation-delay", index);
			});
		}, this.options.scrollPausedTime);
	}

	handleLoad() {
		this.rootEl.querySelectorAll(".svg-draw-path:not(.active)").forEach((pathEl, index) => {
			//   Now reset their delay
			pathEl.style.setProperty("--animation-delay", index);
		});
	}

	handleResize() {
		this.placeElementsInsideAnchors();
	}

	resizeElements() {
		document.querySelectorAll(".capability__container").forEach((contentEl, index) => {
			// Get the target oval
			const targetOvalId = contentEl.dataset.oval;
			const targetOval = this.rootEl.querySelector("[data-anchor-id='" + targetOvalId + "']");

			if (targetOval !== null) {
				this.resizeElementInsideAnchor(targetOval.querySelector("img"), targetOval.offsetWidth);
			}
		});
	}

	resizeElementInsideAnchor(target, size) {
		if (target) {
			target.style.maxWidth = size + "px";
		}
	}
}

(function () {
	document.querySelectorAll("[data-infographic]").forEach((el) => {
		mQ = window.matchMedia("(min-width: 1024px)");
		let svgInfo = new SvgInfographic(el);

		svgInfo = window.matchMedia("(min-width: 1024px)").addEventListener("change", (e) => {
			return new SvgInfographic(el);
		});
	});
})();
